<p-dialog
  header="Application Update Required"
  [visible]="versionService.isMismatch()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  appendTo="body"
  [style]="{ width: '480px' }"
>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-3">
      <i class="pi pi-exclamation-triangle text-4xl! text-(--p-galaxy-severity-warning)"></i>
      <p class="text-(--text-color) leading-relaxed">
        A new version of Galaxy has been deployed. Your current session is out of date
        and must be refreshed before you can continue.
      </p>
    </div>

    <div class="grid grid-cols-2 gap-2 rounded-lg bg-(--surface-section) p-4 text-sm">
      <span class="text-(--text-color-secondary)">Your version</span>
      <span class="font-mono font-semibold text-(--text-color)">{{ versionService.clientVersion }}</span>
      <span class="text-(--text-color-secondary)">Current version</span>
      <span class="font-mono font-semibold text-(--p-galaxy-severity-success)">{{ versionService.serverVersion() ?? '—' }}</span>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end pt-2">
      <p-button
        label="Refresh Page"
        icon="pi pi-refresh"
        (onClick)="refresh()"
      />
    </div>
  </ng-template>
</p-dialog>
